import type { CulturePartnershipFormValues } from "./types";

export const CULTURE_PARTNERSHIP_FORM_DEFAULTS: CulturePartnershipFormValues = {
  organizationName: "",
  countryRegion: "",
  organizationWebsite: "",
  contactName: "",
  contactEmail: "",
  nonprofitStatusVerification: "",
  missionStatement: "",
  organizationType: "",
  referralSource: "",
  annualAudienceReach: "",
  proposedCollaborationType: "",
  partnershipDescription: "",
  launchTimeline: "",
  publiclyReferenceable: "",
  pressKitUrl: "",
  additionalNotes: "",
};

export const organizationTypeOptions = [
  { translationKey: "fieldOptions.organization_type.museum" as const, value: "Museum" },
  { translationKey: "fieldOptions.organization_type.gallery" as const, value: "Gallery" },
  { translationKey: "fieldOptions.organization_type.archive_library" as const, value: "Archive/Library" },
  { translationKey: "fieldOptions.organization_type.festival_event" as const, value: "Festival/Event" },
  { translationKey: "fieldOptions.organization_type.heritage_site" as const, value: "Heritage site" },
  {
    translationKey: "fieldOptions.organization_type.theater_performing_arts" as const,
    value: "Theater/Performing arts",
  },
  { translationKey: "fieldOptions.organization_type.film_media_org" as const, value: "Film/Media org" },
  { translationKey: "fieldOptions.organization_type.creative_collective" as const, value: "Creative collective" },
  { translationKey: "fieldOptions.organization_type.cultural_foundation" as const, value: "Cultural foundation" },
  { translationKey: "fieldOptions.organization_type.other" as const, value: "Other" },
];

export const referralSourceOptions = [
  { translationKey: "fieldOptions.referral_source.web_search" as const, value: "Web search" },
  { translationKey: "fieldOptions.referral_source.partner_referral" as const, value: "Referral from partner" },
  { translationKey: "fieldOptions.referral_source.press_media" as const, value: "Press/media" },
  { translationKey: "fieldOptions.referral_source.social_media" as const, value: "Social media" },
  { translationKey: "fieldOptions.referral_source.event" as const, value: "Event" },
  { translationKey: "fieldOptions.referral_source.other" as const, value: "Other" },
];

export const launchTimelineOptions = [
  { translationKey: "fieldOptions.launch_timeline.within_one_month" as const, value: "Within 1 month" },
  { translationKey: "fieldOptions.launch_timeline.one_to_three_months" as const, value: "1-3 months" },
  { translationKey: "fieldOptions.launch_timeline.three_to_six_months" as const, value: "3-6 months" },
  { translationKey: "fieldOptions.launch_timeline.flexible" as const, value: "Flexible" },
];

export const publiclyReferenceableOptions = [
  { translationKey: "fieldOptions.publicly_referenceable.yes" as const, value: "Yes" },
  { translationKey: "fieldOptions.publicly_referenceable.no" as const, value: "No" },
];

export const fieldConfig = {
  organizationName: { name: "organizationName" as const, required: true },
  countryRegion: { name: "countryRegion" as const, required: true },
  organizationWebsite: { name: "organizationWebsite" as const, required: true },
  contactName: { name: "contactName" as const, required: true },
  contactEmail: { name: "contactEmail" as const, required: true },
  nonprofitStatusVerification: { name: "nonprofitStatusVerification" as const, required: true },
  missionStatement: { name: "missionStatement" as const, required: true },
  organizationType: { name: "organizationType" as const, required: true },
  referralSource: { name: "referralSource" as const, required: true },
  annualAudienceReach: { name: "annualAudienceReach" as const, required: true },
  proposedCollaborationType: { name: "proposedCollaborationType" as const, required: true },
  partnershipDescription: { name: "partnershipDescription" as const, required: true },
  launchTimeline: { name: "launchTimeline" as const, required: true },
  publiclyReferenceable: { name: "publiclyReferenceable" as const, required: true },
  pressKitUrl: { name: "pressKitUrl" as const, required: false },
  additionalNotes: { name: "additionalNotes" as const, required: false },
};
